const app = {
    state: {
        baseUrl: process.env.BASE_PORT
            ? window.location.protocol + "//" + window.location.hostname + ":" + process.env.BASE_PORT
            : window.location.protocol + "//" + window.location.hostname,
    },

    getters:{
    },

    mutations: {
    },

    actions: {
    }
}

export default app



// WEBPACK FOOTER //
// ./src/store/modules/app.js